import React, { FunctionComponent } from 'react'

import { useTemplate } from '___hooks'
import { Button } from 'components/CasusComponents'
import useModal from 'Modal'
import ModalContent from './Relocation.ModalContent'
import { MainLayoutRightPaneTemplateRelocationProps, mainLayoutRightPaneTemplateRelocationClasses as classes } from 'Layouts/___MainLayout'

export const Relocation: FunctionComponent<MainLayoutRightPaneTemplateRelocationProps> = React.memo(({ id }) => {
  const { update, updating } = useTemplate(id)

  const open = useModal({
    header: false,
    content: (...callbacks) => <ModalContent id={id} cancel={callbacks[1]} conclude={callbacks[2]} />,
    onConclude: (_, category) => update({ id, category: category as string }),
    footer: false,
  })

  return (
    <div className={classes.wrapper}>
      <span className={classes.title}>
        Relocation
        <Button onClick={() => open()} onClickBlur disabled={updating} loading={updating}>
          Move
        </Button>
      </span>
    </div>
  )
})

Relocation.displayName = 'MainLayout-RightPane-Template-Relocation'

export default Relocation
